import { useContext } from 'react';
import { useFlexibleAssociations } from './useFlexibleAssociations';
import { useStrategy } from './useStrategy';
import { useUnifiedEventCompletionStatus } from './useUnifiedEventCompletionStatus';
import EditorCrmObjectAssociationSelect from '../components/editor/EditorCrmObjectAssociationSelect';
import EditorUnifiedEventCompletionStatusSelect from '../components/editor/EditorUnifiedEventCompletionStatusSelect';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const useRelatedConditionsHeading = (conditionPath, logicGroup, inputUse) => {
  const {
    getFilterFamilyGroupHeading
  } = useStrategy();
  const {
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    showAssociationSelect
  } = useFlexibleAssociations(logicGroup, conditionPath);
  const {
    showUnifiedEventCompletionStatusSelect
  } = useUnifiedEventCompletionStatus(logicGroup, conditionPath);
  const filterFamilyHeading = getFilterFamilyGroupHeading(logicGroup.filterFamily, logicGroup.associationTypeId, true, baseFilterFamily === logicGroup.filterFamily);
  const showUnifiedEventRefinements = showUnifiedEventCompletionStatusSelect && !logicGroup.hasNotCompletedUnifiedEvent;
  let selectInput = null;
  if (showAssociationSelect) {
    selectInput = /*#__PURE__*/_jsx(EditorCrmObjectAssociationSelect, {
      conditionPath: conditionPath,
      inputUse: inputUse,
      logicGroup: logicGroup
    });
  } else if (showUnifiedEventCompletionStatusSelect) {
    selectInput = /*#__PURE__*/_jsx(EditorUnifiedEventCompletionStatusSelect, {
      conditionPath: conditionPath,
      inputUse: inputUse,
      logicGroup: logicGroup
    });
  }
  return {
    filterFamilyHeading,
    selectInput,
    showUnifiedEventRefinements
  };
};